import { isUndefined } from 'lodash-es';

import { parseDateNumberToNumber } from './parse-date-number-to-number.js';

export const getMinMaxAsNumber = (
  firstValue: number | Date,
  secondValue?: number | Date,
) => {
  const first = parseDateNumberToNumber(firstValue);
  const second = isUndefined(secondValue)
    ? first
    : parseDateNumberToNumber(secondValue);

  return {
    min: Math.min(first, second),
    max: Math.max(first, second),
  };
};
